export default __webpack_public_path__ + "static/media/latakia.88b63087.jpg";